import React from 'react';

const Card = ({
  children,
  variant = 'default',
  hover = false,
  className = '',
  onClick
}) => {
  const baseStyles = 'bg-dark-lighter rounded border border-dark-border transition-all duration-300';

  const variants = {
    default: '',
    elevated: 'shadow-lg',
    bordered: 'border-bronze',
  };

  const hoverStyles = hover ? 'hover:border-bronze hover:shadow-bronze hover:-translate-y-1 cursor-pointer' : '';

  return (
    <div
      className={`${baseStyles} ${variants[variant]} ${hoverStyles} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;
